export default __webpack_public_path__ + "static/media/fatturazione-elettronica.6fd85493.svg";